export * from './src/tips-staff-v1-staff-tippable-staff.universal.js';
